export const isWithinRefElement = (target: HTMLElement | null, elementRef: React.RefObject<HTMLElement>): boolean => {
  if (elementRef && elementRef.current && target) {
    const containerRect = elementRef.current.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    if (
      targetRect.x >= containerRect.x &&
      targetRect.x + targetRect.width <= containerRect.x + containerRect.width &&
      targetRect.y >= containerRect.y &&
      targetRect.y + targetRect.height <= containerRect.y + containerRect.height
    ) {
      return true;
    }
  }
  return false;
};

export const getScrollableAncestor = (node: HTMLElement) => {
  let ancestor = node.parentElement;

  while (ancestor && ancestor !== document.body) {
    const { overflowY } = window.getComputedStyle(ancestor);
    const isScrollable = overflowY === 'auto' || overflowY === 'scroll';

    if (isScrollable && ancestor.scrollHeight > ancestor.clientHeight) {
      return ancestor;
    }

    ancestor = ancestor.parentElement;
  }

  return null;
};
